import { Preferences } from "@capacitor/preferences"

import { isPreferencesAvailable } from "./capacitorPreferences"

import type { PersistenceStorageAdapter } from "m2m-components/storage/useM2mAuth"

const AUTH_KEY = "m2m_auth"

const capacitorStorageAdapter: PersistenceStorageAdapter = {
    async get() {
        const { value } = await Preferences.get({ key: AUTH_KEY })
        if (!value) {
            return undefined
        }
        try {
            return JSON.parse(value)
        } catch {
            // 保存値が壊れている場合は削除して未認証状態に戻す
            await Preferences.remove({ key: AUTH_KEY })
            return undefined
        }
    },
    async set(val) {
        await Preferences.set({ key: AUTH_KEY, value: JSON.stringify(val) })
    },
    async clear() {
        await Preferences.remove({ key: AUTH_KEY })
    }
}

export const getStorageAdapter = (): PersistenceStorageAdapter | undefined => {
    if (isPreferencesAvailable()) {
        return capacitorStorageAdapter
    }
    return undefined
}
